import gql from 'graphql-tag'
import { productGrid } from '../fragments'

const query = gql`
	query listProductsGridView {
		cashAssist {
			listProducts {
				items {
					...productGrid
				}
				cursors {
					hasNext
					hasPrevious
					before
					after
				}
				hasNextPage
				total
			}
		}
	}
${productGrid}`
export default query
